import { render, staticRenderFns } from "./myBox.vue?vue&type=template&id=d00170ce&"
import script from "./myBox.vue?vue&type=script&lang=js&"
export * from "./myBox.vue?vue&type=script&lang=js&"
import style0 from "./myBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports